import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { ChequesPage } from './ChequesPage'

const TAB_CHEQUES = 'cheques'

export const DocumentsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') || TAB_CHEQUES

  const setTab = (value: string) => {
    setSearchParams({ tab: value })
  }

  return (
    <div className="w-full">
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold esales-text font-display">Personal Documents</h1>
        <p className="text-muted-foreground mt-1">Manage your personal business documents</p>
      </div>

      <div className="flex gap-1 p-1 rounded-xl bg-muted/30 border border-border/50 w-fit mb-6">
        <button
          type="button"
          onClick={() => setTab(TAB_CHEQUES)}
          className={tab === TAB_CHEQUES ? 'glow-button px-5 py-2.5 text-sm rounded-lg' : 'px-5 py-2.5 rounded-lg text-sm font-semibold text-muted-foreground hover:text-foreground transition-all'}
        >
          Cheques
        </button>
        <button
          type="button"
          disabled
          className="px-5 py-2.5 rounded-lg text-sm font-semibold text-muted-foreground/40 cursor-not-allowed"
          title="Coming soon"
        >
          IOUs & Loans
        </button>
        <button
          type="button"
          disabled
          className="px-5 py-2.5 rounded-lg text-sm font-semibold text-muted-foreground/40 cursor-not-allowed"
          title="Coming soon"
        >
          Documents
        </button>
      </div>

      <div className="min-h-[400px]">
        {tab === TAB_CHEQUES && <ChequesPage embedded />}
      </div>
    </div>
  )
}
